import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNewPatientContext } from "../store/NewPatientContextProvider";
import { getStudyProcedure } from "./../api/api";

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

const MODAL_STYLES = {
  bgcolor: "#fff",
  color: "#111",
  p: 4,
};

const ageCheck = (IDNumber) => {
  var tempDate = new Date(
    IDNumber.substring(0, 2),
    IDNumber.substring(2, 4) - 1,
    IDNumber.substring(4, 6)
  );

  var diff_ms = Date.now() - tempDate.getTime();
  var age_dt = new Date(diff_ms);
  var age = Math.abs(age_dt.getUTCFullYear() - 1970);
  return age;
};

const JobCard = () => {
  //const { newPatient } = useNewPatientContext();
  const [studyProcedure, setStudyProcedure] = useState();
  let procedure = JSON.parse(localStorage.getItem("current-procedure"));
  let newPatient = JSON.parse(localStorage.getItem("currentPatient"));
  console.log("procedure", procedure);
  const [form, setForm] = useState({
    Date: new Date(),
    InjuryDate: newPatient.MedicalAidDetails.IncidentDate,
    Branch: newPatient.PatientDetails.Branch,
    CapturedBy: procedure.AssignedReceptionist,
    VisitNumber: " ",
    FirstName: newPatient.PatientDetails.FirstName,
    LastName: newPatient.PatientDetails.LastName,
    Initials: newPatient.PatientDetails.Initials,
    Title: newPatient.PatientDetails.Title,
    Language: "English",
    Age: ageCheck(newPatient.PatientDetails.IDNumber),
    WCA: " ",
    ClaimNo: " ",
    WorkOrHomeNumber: newPatient.PatientDetails.PhoneNumber,
    MemberEmail: newPatient.MedicalAidDetails.Email,
    MemberTitle: newPatient.MedicalAidDetails.MedicalAidMemberTitle,
    MemberFullName: newPatient.MedicalAidDetails.MedicalAidMemberFirstName
      ? newPatient.MedicalAidDetails.MedicalAidMemberFirstName +
        " " +
        newPatient.MedicalAidDetails.MedicalAidMemberLastName
      : "",
    MemberInitials: newPatient.MedicalAidDetails.MedicalAidMemberFirstName.charAt(0) + newPatient.MedicalAidDetails.MedicalAidMemberLastName.charAt(0),
    MemberIDNumber: newPatient.MedicalAidDetails.MedicalAidMemberIDNumber,
    MemberPostalAddress:
      newPatient.MedicalAidDetails.MedicalAidMemberPostalAddress.label,
    MemberResidentialAddress:
      newPatient.MedicalAidDetails.MedicalAidMemberPostalAddress.label,
    MemberPatientAddress:
      newPatient.MedicalAidDetails.MedicalAidMemberPostalAddress.label,
    MedicalAidName: newPatient.MedicalAidDetails.MedicalAidName,
    MedicalAidRefNo: newPatient.MedicalAidDetails.MedicalAidNumber,
    RefDoctor: procedure.AssignedRefDoctor,
    Allergies: " ",
    Asthma: " ",
    IsPregnant: procedure.Pregnant,
    Signature: " ",
    Radiographer: procedure.AssignedRadiographer,
    Radiologist: procedure.AssignedRadiologist,
    Consumables: " ",
    ExamNotes: procedure.SideNote,
    MedicalAidPlan: newPatient.MedicalAidDetails.MedicalAidPlan
  });

  useEffect(async () => {
    document.title = "Job Card";
    let procedure = JSON.parse(localStorage.getItem("current-procedure"));
    const [res, err] = await getStudyProcedure(procedure.AccessionNumber);
    if (res) {
      let procArr = [];
      res.data.forEach((proc) => {
        procArr.push(proc.Procedure);
      });
      console.log("procArr", procArr);

      let procString = procArr.join(", ");
      setStudyProcedure(procString);
      console.log("StudyProcedure", studyProcedure);
    }
    
  }, []);

  const handleInputChange = (e) => {
    setForm({
      ...form,
      [e.target.id]: e.target.value,
    });
  };

  const handlePrintRequest = (e) => {
    e.currentTarget.style.display = "none";
    window.print();
    e.currentTarget.style.display = "flex";
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={MODAL_STYLES}>
        <Box sx={{ flexGrow: 1, flexWrap: "wrap" }}>
          <Grid container spacing={2}>
            {/* QC RECORD DATA START */}
            <Grid item xs={12}>

              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Branch/Tak"
                    id="Branch"
                    value={form.Branch}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    sx={{ color: "red !important" }}
                    fullWidth
                    variant="outlined"
                    helperText="Captured by"
                    id="CapturedBy"
                    value={form.CapturedBy}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Visit Number"
                    id="VisitNumber"
                    value={form.VisitNumber}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Title"
                    id="Title"
                    value={form.Title}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Initials"
                    id="Initials"
                    value={form.Initials}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Last Name"
                    id="LastName"
                    value={form.LastName}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="First Names"
                    value={form.FirstName}
                    onChange={handleInputChange}
                    id="FirstName"
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Language"
                    id="Language"
                    value={form.Language}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                    <TextField
                      id="Injury Date"
                      label="Injury Date"
                      type="datetime-local"
                      defaultValue={form.InjuryDate}
                      onChange={(newValue) => {
                        setForm({
                          ...form,
                          InjuryDate: newValue,
                        });
                      }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="number"
                    helperText="Age"
                    id="Age"
                    value={form.Age}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="WCA"
                    id="WCA"
                    value={form.WCA}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Claim No"
                    id="ClaimNo"
                    value={form.ClaimNo}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Work / Home No."
                    id="WorkOrHomeNumber"
                    value={form.WorkOrHomeNumber}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    type="email"
                    fullWidth
                    variant="outlined"
                    helperText="Member Email"
                    id="MemberEmail"
                    value={form.MemberEmail}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Member Title"
                    id="MemberTitle"
                    value={form.MemberTitle}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Member Initials"
                    id="MemberInitials"
                    value={form.MemberInitials}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Member Full Name"
                    id="MemberFullName"
                    value={form.MemberFullName}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Member ID Number"
                    id="MemberIDNumber"
                    value={form.MemberIDNumber}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    helperText="Member Postal Address"
                    id="MemberPostalAddress"
                    value={form.MemberPostalAddress}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    helperText="Member Residential Address"
                    id="MemberResidentialAddress"
                    value={form.MemberResidentialAddress}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="MedicalAidPlan"
                    id="MedicalAidPlan"
                    value={form.MedicalAidPlan}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Medical Aid Name"
                    id="MedicalAidName"
                    value={form.MedicalAidName}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Medical Aid Ref No"
                    id="MedicalAidRefNo"
                    value={form.MedicalAidRefNo}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Ref Doctor"
                    id="RefDoctor"
                    value={form.RefDoctor}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <TextField
                size="small"
                multiline
                rows={3}
                fullWidth
                variant="outlined"
                helperText="Procedures"
                id="procedure"
                value={studyProcedure}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Box style={{ fontSize: 13, margin: "20px 0" }}>
                I hereby give consent for the injection or other administration
                on any drugs or contrast medicine which may be necessary for the
                performance of the xray examination
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Allergies (specify)"
                    id="Allergies"
                    value={form.Allergies}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Asthma"
                    id="Asthma"
                    value={form.Asthma}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Are you pregnant"
                    id="IsPregnant"
                    value={form.IsPregnant}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Signature"
                    id="Signature"
                    value={form.Signature}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      value={form.Date}
                      onChange={(newValue) => {
                        setForm({
                          ...form,
                          Date: newValue,
                        });
                      }}
                      helperText="Date/Datum"
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          variant="outlined"
                          {...params}
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Radiographer"
                    id="Radiographer"
                    value={form.Radiographer}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    helperText="Radiologist"
                    id="Radiologist"
                    value={form.Radiologist}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    helperText="Consumables"
                    id="Consumables"
                    value={form.Consumables}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    helperText="Exam Notes"
                    size="small"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    id="ExamNotes"
                    value={form.ExamNotes}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Button
          color="primary"
          variant="contained"
          sx={{ mt: 2 }}
          id="print-btn"
          onClick={handlePrintRequest}
        >
          Print Job Card
        </Button>
      </Box>
    </ThemeProvider>
  );
};

export default JobCard;
